import { render, staticRenderFns } from "./settings.pug?vue&type=template&id=e44ca090&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./settings.scss?vue&type=style&index=0&id=e44ca090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44ca090",
  null
  
)

export default component.exports